import axios from 'axios'
import { SERVER_URI } from '../utils/config'
import { checkToken } from './checkToken'

export const dbupdate = async (table, id, data) => {
	checkToken()
	try{
		const response = await axios.put(`${SERVER_URI}/${table}/${id}`, data)
		return response.data
	} catch (err) {
		console.error(err)
		throw new Error('Error updating data')
	}
}
